import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { NameSpace, contactForm } from "../../data/AppLanguage";

const SpinnerAnimation = () => {
  const { t } = useTranslation([NameSpace.COMMON]);

  return (
    <Spinner animation="border" role="status">
      <span className="sr-only">{t(`${contactForm}loading`)}</span>
    </Spinner>
  );
};

export default SpinnerAnimation;
